import React from 'react';
import { CalendarDays as CalendarDaysIcon, ListChecks as ListChecksIcon, LockKeyhole as LockKeyholeIcon, ShoppingBasket as ShoppingBasketIcon, Soup as SoupIcon, Utensils as UtensilsIcon, Zap as ZapIcon } from 'lucide-react';
const offerItems = [{
  icon: UtensilsIcon,
  name: '21 Days of Radiant Mornings',
  detail: 'The Bread-Free Breakfast Plan for Women in Menopause',
  value: '$37.00',
  included: 'INCLUDED'
}, {
  icon: CalendarDaysIcon,
  name: 'Bonus #1 — 7-Day Starter Meal Plan',
  detail: 'A full week of breakfasts, planned for you',
  value: '$10.00',
  included: 'FREE'
}, {
  icon: ShoppingBasketIcon,
  name: 'Bonus #2 — Smart Grocery List',
  detail: 'Everything to keep stocked, nothing wasted',
  value: '$10.00',
  included: 'FREE'
}, {
  icon: ZapIcon,
  name: 'Bonus #3 — Weekend Prep Guide',
  detail: '30 min on Sunday = stress-free week',
  value: '$10.00',
  included: 'FREE'
}, {
  icon: ListChecksIcon,
  name: 'Bonus #4 — Hormone-Friendly Pantry Checklist',
  detail: 'Support hormonal balance after 50',
  value: '$10.00',
  included: 'FREE'
}, {
  icon: SoupIcon,
  name: 'Bonus #5 — 10 Smoothies to Beat the Energy Crash',
  detail: 'Blood sugar balance in under 3 minutes',
  value: '$10.00',
  included: 'FREE'
}];
export function OfferSection() {
  return <section id="offer" className="bg-cream py-20 sm:py-24" data-id="element-108">
      <div className="mx-auto max-w-5xl px-5 lg:px-8" data-id="element-109">
        <div className="text-center" data-id="element-110">
          <p className="eyebrow" data-id="element-111">Special offer</p>
          <h2 className="section-title mt-3" data-id="element-112">
            Invest in your mornings once — feel the difference for life
          </h2>
          <p className="mx-auto mt-5 max-w-2xl leading-7 text-forest/70" data-id="element-113">
            Less than the cost of a single breakfast out. You get the complete
            system — 50 recipes + 5 bonuses — for a one-time price that will
            make you wonder why it&apos;s this low.
          </p>
        </div>
        <div className="mt-12 overflow-hidden rounded-3xl border border-forest/15 bg-white shadow-xl shadow-forest/5" data-id="element-114">
          <div className="border-b border-forest/10 bg-forest px-6 py-5 text-cream sm:px-8" data-id="element-115">
            <h3 className="font-serif text-2xl" data-id="element-116">Everything you get today</h3>
          </div>
          <div className="p-5 sm:p-8" data-id="element-117">
            {offerItems.map(({
            icon: Icon,
            name,
            detail,
            value,
            included
          }) => <div key={name} className="flex gap-3 border-b border-forest/10 py-4 last:border-0" data-id="element-118">
                <Icon size={20} className="mt-1 shrink-0 text-olive" data-id="element-119" />
                <div className="flex-1" data-id="element-120">
                  <h4 className="text-sm font-extrabold text-forest" data-id="element-121">{name}</h4>
                  <p className="mt-1 text-xs text-forest/65" data-id="element-122">{detail}</p>
                </div>
                <div className="shrink-0 text-right" data-id="element-123">
                  <p className="text-sm font-semibold text-forest/60" data-id="element-124">
                    {value}
                  </p>
                  <p className="mt-1 text-xs font-extrabold text-terracotta" data-id="element-125">
                    {included}
                  </p>
                </div>
              </div>)}
            <div className="mt-5 grid gap-4 rounded-2xl bg-sand p-5 sm:grid-cols-2 sm:items-center" data-id="element-126">
              <div data-id="element-127">
                <p className="text-sm font-bold text-forest/65" data-id="element-128">
                  Total real value
                </p>
                <p className="font-serif text-3xl text-forest line-through decoration-terracotta" data-id="element-129">
                  $87.00
                </p>
              </div>
              <div className="sm:text-right" data-id="element-130">
                <p className="text-sm font-bold text-forest/65" data-id="element-131">
                  You pay today{' '}
                  <span className="font-normal" data-id="element-132">
                    · One-time · Lifetime access
                  </span>
                </p>
                <p className="font-serif text-4xl text-terracotta" data-id="element-133">$19.99</p>
                <p className="mt-1 text-xs font-extrabold text-olive" data-id="element-134">
                  You save $67.01 (77.02% OFF)
                </p>
              </div>
            </div>
            <a id="purchase" href="https://pay.hotmart.com/N106717501L" className="mt-6 flex w-full items-center justify-center gap-3 rounded-full bg-terracotta px-6 py-5 text-center text-base font-extrabold tracking-wide text-white shadow-lg shadow-terracotta/25 transition hover:bg-[#a84a35] focus:outline-none focus:ring-4 focus:ring-terracotta/30" data-id="element-135">
              YES — CLAIM MY 21 DAYS OF RADIANT MORNINGS NOW →
            </a>
            <p className="mt-4 flex items-center justify-center gap-2 text-center text-xs font-semibold text-forest/60" data-id="element-136">
              <LockKeyholeIcon size={13} data-id="element-137" /> Secure checkout · Instant delivery
              to your email · 7-day guarantee
            </p>
          </div>
        </div>
      </div>
    </section>;
}